<template>
  <div
    class="card"
    v-bind:class="{
      'card--red': card && card.color === 'red',
      'card--yellow': card && card.color === 'yellow',
      'card--green': card && card.color === 'green',
      'card--blue': card && card.color === 'blue',
      'card--joker': card && card.joker,
      'card--stock': stock
    }"
    @dragstart="dragStart($event)"
    v-bind:draggable="active"
  >
    <template v-if="card && !card.joker">
      <div class="card__small">
        {{ card.number }}
      </div>
      <div class="card__big">{{ card.number }}</div>
      <div class="card__small card__small--bottom">
        {{ card.number }}
      </div>
    </template>
    <template v-else-if="card && card.joker">
      <div class="card__small">
        Skip-Bo
      </div>
      <div class="card__big">Skip-Bo</div>
      <div class="card__small card__small--bottom">
        Skip-Bo
      </div>
    </template>
    <template v-else-if="stock">
      <div class="card__big">
        Stapel
      </div>
    </template>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    card: {
      type: Object,
      default() {
        return null;
      }
    },
    active: {
      type: Boolean,
      default: false
    },
    stock: {
      type: Boolean,
      default: false
    },
    from: {
      validator: value => {
        return ['hand', 'putAway', 'stock'].includes(value);
      }
    },
    position: {
      type: Number,
      default: null
    }
  },
  methods: {
    dragStart($event) {
      $event.dataTransfer.setData('card', JSON.stringify(this.card));
      $event.dataTransfer.setData('from', this.from);
      $event.dataTransfer.setData('position', this.position);
      $event.dataTransfer.dropEffect = 'move';
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  width: 56px;
  height: 80px;
  background-color: #fff;
  border: 2px solid #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 4px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 3px 0px;
  display: flex;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  text-transform: uppercase;
  color: #fff;
  cursor: default;

  &[draggable='true'] {
    cursor: pointer;
  }

  &--red {
    background-color: #bf0404;
  }

  &--yellow {
    background-color: #f2cb07;
  }

  &--green {
    background-color: #038c3e;
  }

  &--blue,
  &--joker {
    background-color: #048abf;
  }

  &--joker & {
    &__small {
      font-size: 6px;
      padding: 1px 2px;
      top: 5px;
      left: 0;
      width: 100%;
      text-align: center;

      &--bottom {
        top: auto;
        left: auto;
        bottom: 5px;
        right: 0;
      }
    }

    &__big {
      font-size: 11px;
      border-top: 2px solid #fff;
      border-bottom: 2px solid #fff;
    }
  }

  &--stock {
    background-color: #f2f2f2;
  }

  &--stock & {
    &__big {
      font-size: 11px;
      color: #150b0b;
      border-top: 2px solid #150b0b;
      border-bottom: 2px solid #150b0b;
    }
  }

  &__small {
    font-size: 11px;
    position: absolute;
    top: 5px;
    left: 5px;

    &--bottom {
      transform: rotate(180deg);
      top: auto;
      left: auto;
      bottom: 5px;
      right: 5px;
    }
  }

  &__big {
    font-size: 16px;
  }
}
</style>
